export default {"src":"https://assets.ctr1.net/f424c52a729e/_next/static/media/c1-icon-light.9f867260.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};